import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "container-fluid h-100 mt-2 mb-2 p-0" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-12" };
const _hoisted_4 = { class: "fw-bold fs-5 mb-1" };
const _hoisted_5 = { class: "row mb-4" };
const _hoisted_6 = { class: "d-grid gap-3 mb-4" };
const _hoisted_7 = { class: "d-flex flex-row" };
const _hoisted_8 = { class: "ps-3 flex-fill" };
const _hoisted_9 = { class: "d-flex flex-column" };
const _hoisted_10 = { class: "fs-5 fw-bold" };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = {
    class: "d-flex flex-row border-top mt-2 pt-2",
    style: { "border-top-style": "dashed !important" }
};
const _hoisted_13 = { class: "dev__avatar-small text-white bg-primary" };
const _hoisted_14 = { class: "ps-3 flex-fill d-flex flex-column small justify-content-center" };
const _hoisted_15 = { class: "mt-1 mb-1 text-end d-flex flex-row" };
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
    class: "border-top mt-2 pt-2 d-flex justify-content-end",
    style: { "border-top-width": "1px !important" }
};
const _hoisted_19 = {
    key: 0,
    class: "flex-fill"
};
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("div", { class: "dev__avatar-small text-white bg-danger h-100" }, " BETA ", -1);
const _hoisted_21 = [
    _hoisted_20
];
const _hoisted_22 = ["href"];
const _hoisted_23 = {
    key: 1,
    class: "row"
};
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("div", { class: "col-12 text-center" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "alert alert-secondary" }, " Keine Anträge vorhanden... ")
], -1);
const _hoisted_25 = [
    _hoisted_24
];
const _hoisted_26 = {
    key: 0,
    class: "row mb-2"
};
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("div", { class: "col fw-bold fs-5" }, " Einen neuen Antrag stellen ", -1);
const _hoisted_28 = [
    _hoisted_27
];
const _hoisted_29 = { class: "row" };
const _hoisted_30 = { class: "col-12" };
const _hoisted_31 = { class: "fw-bold fs-5 mb-1" };
const _hoisted_32 = { class: "d-grid gap-3 mb-4" };
const _hoisted_33 = { class: "p-2 forms_schema-card" };
const _hoisted_34 = { class: "d-flex flex-row" };
const _hoisted_35 = { class: "ps-3 flex-fill" };
const _hoisted_36 = { class: "d-flex flex-column" };
const _hoisted_37 = { class: "fs-5 fw-bold" };
const _hoisted_38 = {
    key: 0,
    class: "d-flex border-top mt-2"
};
const _hoisted_39 = ["innerHTML"];
const _hoisted_40 = {
    class: "border-top mt-2 pt-2 d-flex justify-content-end",
    style: { "border-top-width": "1px !important" }
};
const _hoisted_41 = {
    key: 0,
    class: "flex-fill"
};
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("div", { class: "dev__avatar-small text-white bg-danger h-100" }, " BETA ", -1);
const _hoisted_43 = [
    _hoisted_42
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_button = _resolveComponent("g-button");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.processes.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.$utils.groupBy(_ctx.processes, 'state.groupKey'), (tProcesses) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, _toDisplayString(tProcesses[0].state.groupLabel), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tProcesses, (process) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: "p-2 forms_schema-card",
                                    key: process.processID
                                }, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(['dev__avatar text-white', process.schemaColor ? (process.schemaColor[0] === '#' ? '' : 'bg-' + process.schemaColor) : 'bg-primary']),
                                            style: _normalizeStyle([process.schemaColor && process.schemaColor[0] === '#' ? ('background-color:' + process.schemaColor) : ''])
                                        }, _toDisplayString(process.processNumber), 7),
                                        _createElementVNode("div", _hoisted_8, [
                                            _createElementVNode("div", _hoisted_9, [
                                                _createElementVNode("div", _hoisted_10, [
                                                    _createTextVNode(_toDisplayString(process.caption), 1),
                                                    (process.schemaShortCut)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createTextVNode(" (" + _toDisplayString(process.schemaShortCut) + ")", 1)
                                                        ], 64))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", null, "vom " + _toDisplayString(_ctx.$utils.formatDate(Date.parse(process.createdAt))), 1)
                                            ])
                                        ])
                                    ]),
                                    (process.subProcesses)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(process.subProcesses, (sub) => {
                                                return (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                    _createElementVNode("div", _hoisted_13, _toDisplayString(sub.processIndex), 1),
                                                    _createElementVNode("div", _hoisted_14, _toDisplayString(sub.caption) + " vom " + _toDisplayString(_ctx.$utils.formatDate(Date.parse(sub.createdAt))) + " (Status: " + _toDisplayString(sub.state.label) + ") ", 1),
                                                    _createElementVNode("div", _hoisted_15, [
                                                        (sub.state.allowEdit)
                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                key: 0,
                                                                class: "btn btn-outline-secondary p-1",
                                                                style: { "line-height": "0" },
                                                                onClick: ($event) => (_ctx.onGoto(sub))
                                                            }, [
                                                                _createVNode(_component_g_icon, { src: "/assets/icons/pencil.svg" })
                                                            ], 8, _hoisted_16))
                                                            : _createCommentVNode("", true),
                                                        (sub.state.allowDelete)
                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                key: 1,
                                                                class: "btn btn-outline-danger p-1 ms-1",
                                                                style: { "line-height": "0" },
                                                                onClick: ($event) => (_ctx.onDelete(sub))
                                                            }, [
                                                                _createVNode(_component_g_icon, { src: "/assets/icons/trash.svg" })
                                                            ], 8, _hoisted_17))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ]));
                                            }), 256))
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_18, [
                                        (process.phase !== 'released')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", null, [
                                            (process.state.allowEdit)
                                                ? (_openBlock(), _createBlock(_component_g_button, {
                                                    key: 0,
                                                    text: "Bearbeiten",
                                                    class: "btn-sm ms-1 w-fixed-100",
                                                    onClick: ($event) => (_ctx.onGoto(process))
                                                }, null, 8, ["onClick"]))
                                                : _createCommentVNode("", true),
                                            (process.state.allowDocView)
                                                ? (_openBlock(), _createBlock(_component_g_button, {
                                                    key: 1,
                                                    text: "Alle Dokumente anzeigen",
                                                    class: "btn-sm ms-1",
                                                    onClick: ($event) => (_ctx.onMissingDocuments(process))
                                                }, null, 8, ["onClick"]))
                                                : _createCommentVNode("", true),
                                            (process.state.allowDocUpload)
                                                ? (_openBlock(), _createBlock(_component_g_button, {
                                                    key: 2,
                                                    text: "Weitere Dokumente hochladen",
                                                    class: "btn-sm ms-1",
                                                    onClick: ($event) => (_ctx.onDocuments(process))
                                                }, null, 8, ["onClick"]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("a", {
                                                href: '/frontend/v1/forms/processes/' + process.processID + '/print',
                                                target: "_blank",
                                                class: "btn btn-primary btn-sm ms-1 text-white w-fixed-100"
                                            }, "Drucken", 8, _hoisted_22),
                                            (process.state.allowDelete)
                                                ? (_openBlock(), _createBlock(_component_g_button, {
                                                    key: 3,
                                                    text: "Löschen",
                                                    "button-style": "btn-danger",
                                                    class: "btn-sm ms-1 w-fixed-100",
                                                    onClick: ($event) => (_ctx.onDelete(process))
                                                }, null, 8, ["onClick"]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ]));
                            }), 128))
                        ])
                    ])
                ], 64));
            }), 256))
            : (_ctx.schemas.length === 0 && _ctx.isLoaded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                : _createCommentVNode("", true),
        (_ctx.isNew && _ctx.schemas.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.mode === 'all')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$utils.groupBy(_ctx.schemas, 'groupKey'), (schemas, groupKey) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                        _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, _toDisplayString(schemas[0].groupLabel), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schemas, (schema) => {
                                return (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createElementVNode("div", _hoisted_34, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(['dev__avatar text-white', schema.color ? (schema.color[0] === '#' ? '' : 'bg-' + schema.color) : 'bg-primary']),
                                            style: _normalizeStyle([schema.color && schema.color[0] === '#' ? ('background-color:' + schema.color) : ''])
                                        }, _toDisplayString(schema.shortCut), 7),
                                        _createElementVNode("div", _hoisted_35, [
                                            _createElementVNode("div", _hoisted_36, [
                                                _createElementVNode("div", _hoisted_37, _toDisplayString(schema.label), 1),
                                                _createElementVNode("div", null, _toDisplayString(schema.description), 1)
                                            ])
                                        ])
                                    ]),
                                    (schema?.messages && schema.messages.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schema?.messages, (message) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    class: _normalizeClass(['alert d-flex align-items-center pt-2 pb-2 small w-100 mb-0 mt-2', message.style ? 'alert-' + message.style : 'alert-warning']),
                                                    role: "alert"
                                                }, [
                                                    (message.iconUrl)
                                                        ? (_openBlock(), _createBlock(_component_g_icon, {
                                                            key: 0,
                                                            class: "flex-shrink-0 me-2",
                                                            width: "24",
                                                            height: "24",
                                                            src: message.iconUrl,
                                                            "aria-label": "Warning:"
                                                        }, null, 8, ["src"]))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("div", {
                                                        innerHTML: message.description
                                                    }, null, 8, _hoisted_39)
                                                ], 2));
                                            }), 256))
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_40, [
                                        (schema.phase !== 'released')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", null, [
                                            (schema.hasInfoPage)
                                                ? (_openBlock(), _createBlock(_component_g_button, {
                                                    key: 0,
                                                    text: "Informationen",
                                                    class: "btn-sm ms-1 w-fixed-150",
                                                    onClick: ($event) => (_ctx.onInfo(schema))
                                                }, null, 8, ["onClick"]))
                                                : _createCommentVNode("", true),
                                            _createVNode(_component_g_button, {
                                                text: "Jetzt starten...",
                                                class: "btn-sm ms-1 w-fixed-150",
                                                onClick: ($event) => (_ctx.onCreateNew(schema.name, schema.version)),
                                                disabled: !schema.allowCreate
                                            }, null, 8, ["onClick", "disabled"])
                                        ])
                                    ])
                                ]));
                            }), 256))
                        ])
                    ], 64));
                }), 256))
            ], 64))
            : _createCommentVNode("", true)
    ]));
}
